export default "__VITE_ASSET__BBkDPq7I__"